import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { BillingItem } from "../types";


export const createBill = (payload: BillingItem) => {
   return apiClient<ApiResponse>("/v1/bill", {
      method: "POST",
      body: payload
   })
}